


import {SessionType} from './SessionType'; 
import {SessionDuration} from './SessionDuration'; 
export class OrganisationSessionPreferencesVM {
    
    sessionTypes?: SessionType;
    
    durations?: SessionDuration;
    
}
